<template>
  <button id="dtl-btn" class="bg-black rounded-md p-4" :title="t('dtl.grade', { grade: hasAlternatives ? t('menu.news') : grade })" data-icon="leaf" :data-grade="grade" :data-new="hasAlternatives ? true : undefined">
    <span lang="en" class="sr-only">{{ t('dtl.title') }}</span>
    <span v-if="hasAlternatives" lang="en" class="new">{{ t('menu.news') }}</span>
  </button>
</template>
<script setup>
import { storeToRefs } from "pinia";
import { usePageStore } from "../../stores/page";
import { computed } from "vue";
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const { page } = storeToRefs(usePageStore());

const hasAlternatives = computed(() => {
  return page.value.designToLight.length > 1;
});

const grade = computed(() => {
  if (hasAlternatives.value) return "new";
  return page.value.designToLight[0].grades.global.letter;
});
</script>
